import React from 'react';
import IMBody from 'im-react/IMBody';

export default function IMBodyExample() {

  return (
    <div>
      <IMBody></IMBody>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/docs/examples/IMBody/ExampleIMBody.js